module.exports = __webpack_public_path__ + "check.1K4-0WiS.svg";